import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { User } from './user.interface';

export interface UserServiceInterface {
   getUsers(query: LocationQuery): Promise<ApiResource<User>>;
   getUser(userId: number, query: LocationQuery): Promise<User>;
   postUser(user: User): Promise<User>;
   putUser(userId: number, user: User): Promise<User>;
   deleteUser(userId: number): Promise<User>;
}

export class UserService implements UserServiceInterface {
   async getUsers(query: LocationQuery): Promise<ApiResource<User>> {
      return await http.get<ApiResource<User>>(`/users`, { params: { ...query } }).then((response) => response.data);
   }

   async getUser(userId: number, query: LocationQuery): Promise<User> {
      return await http.get<User>(`/users/${userId}`, { params: { ...query } }).then((response) => response.data);
   }

   async postUser(user: User): Promise<User> {
      return await http.post<User>(`/users`, user).then((response) => response.data);
   }

   async putUser(userId: number, user: User): Promise<User> {
      return await http.put<User>(`/users/${userId}`, user).then((response) => response.data);
   }

   async deleteUser(userId: number): Promise<User> {
      return await http.delete<User>(`/users/${userId}`).then((response) => response.data);
   }
}
